import { Component, NgZone } from "@angular/core";
import { localDataService, localDataServices } from "../../Services/localDataServices";
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { C } from "@angular/core/src/render3";
import { promise } from "protractor";
import { resolve } from "url";
import { PromiseType } from "protractor/built/plugins";
import { format } from "date-fns";
declare var $: any;  //定义jquery
declare var async: any;  //定义jquery
@Component({
    selector: 'identification',
    providers: [localDataServices],
    templateUrl: './identification.html',
    styleUrls: ['./identification.css']
})

export class identificationComponent {
    tabs: 'tabs1' | 'tabs2' = 'tabs1';
    isFillLayout: boolean = false;
    token: string;
    orderNo: string;
    delays: number = 1;
    setDelays: number = 20;
    modalVibisity: boolean = false;
    attrJson: any = {
        shipper: { value: '' }, // 发货人
        ourCompanyNo: { value: '' }, // 同行编号
        placeOfReceiptStandard: { value: '' }, // 收货地
        placeOfReceiptMP: { value: '' }, // 收货地五字码
        consignee: { value: '' }, // 收货人
        notifyParty: { value: '' }, // 通知人
        portOfLoadingStandard: { value: '' }, // 起运港
        portOfLoadingMP: { value: '' }, // 起运港五字码
        portOfDischargeStandard: { value: '' }, // 卸货港
        portOfDischargeMP: { value: '' }, // 卸货港五字码
        portOfDestinationStandard: { value: '' }, // 目的港
        portOfDestinationMP: { value: '' }, // 目的港五字码
        numberOfPieces: { value: '' }, // 件数
        grossWeight: { value: '' }, // 毛重
        volume: { value: '' }, // 体积
        packing: { value: '' }, // 包装
        etd: { value: '' }, // 要求ETD
        serviceTerm: { value: '' }, // 运输条款
        paymenTerm: { value: '' }, // 运费条款
        client: { value: '' }, // 委托方
        contacts: { value: '' }, // 联系人
        contactPhone: { value: '' }, // 联系人电话
        goodName: { value: '' }, // 品名
        marks: { value: '' }, // 唛头
        remarks: { value: '' }, // 备注
        /* -------------------------- */
        imgPath: '', // 图片
        originalPath: '' // 源文件
    };
    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _localDataService: localDataService,
        private _location: Location,
        private ngZone: NgZone,

    ) {

    }

    ngOnInit() {
        this._activatedRoute.queryParams.subscribe(params => {
            if (params.delays > 0) {
                this.setDelays = params.delays;
            }
        })


        this._activatedRoute.params.subscribe((params => {
            this.token = params.token;
            this.orderNo = params.orderNo;
            this.identifyData(params);
            this.getSomeType();
        }))


    }
    ngAfterContentInit() {
        $('#myModal').on('hidden.bs.modal', (e) => {
            this.ngZone.run(() => {
                this.openModalType = null;
                this.focusIdx = -1
                this.checkedIdx - 1
                document.querySelector('.modal-body-table').scrollTop = 0
            })
        })
        $('#exampleModal').on('hidden.bs.modal', (e) => {
            this.ngZone.run(() => {
                this.portForm = { portName: '', portCode: '', countryCode: '', countryName: '', countryEnName: '' };
                this.portVName = false;
                this.portVCode = false;
                this.portCodeArray = [];
            })
        })
    }


    // 获取 单证数据 
    isTypeDate: boolean = true;
    identifyData(params: any = { token: this.token, orderNo: this.orderNo }) {
        this.modalVibisity = true;
        if (this.delays >= this.setDelays) { this.delays = 0 }
        let timer = setInterval(() => {
            if (this.delays >= this.setDelays) { return clearInterval(timer) }
            this.delays++;
        }, 1200)
        this._localDataService.identDetails(params)
            .then((res: any) => {
                let { status, data: { attrJson = { etd: { value: '' } } }, message } = res;
                if (status) {
                    try {
                        if (attrJson.etd.value) {
                            attrJson.etd.value = format(new Date(attrJson.etd.value), 'yyyy-MM-dd');
                        }
                    } catch (error) {
                        try {
                            if (attrJson.etd.value) {
                                const formatDate = attrJson.etd.value.replace('日', '').replace(/年|月/g, '-')
                                attrJson.etd.value = format(new Date(formatDate), 'yyyy-MM-dd');
                            }
                        } catch (error) {
                            console.error('etd.value:' + attrJson.etd.value);
                            attrJson.etd.value = null;
                        }
                    }
                    this.attrJson = attrJson;
                    clearInterval(timer);
                    this.modalVibisity = false;
                    // this.drawLoading();
                } else {
                    alert(message);
                    clearInterval(timer);
                    this.modalVibisity = false;
                }
            })
    }
    debounce(func, delays) {
        let timer = null;
        return () => {
            if (timer) { clearTimeout(timer) }
            timer = setTimeout(() => {
                func.apply(this)
            }, delays)
        }
    }
    debounceIdentifyData = this.debounce(this.identifyData, 300)

    // 保存
    updataHander(event, setType) {
        let $btn = $(event.target).button('loading')
        if (this.attrJson.etd.value) {
            this.attrJson.etd.value = format(new Date(this.attrJson.etd.value), 'yyyy-MM-dd');
        }
        this._localDataService.saveIdentDetails({ token: this.token, orderNo: this.orderNo, msCoID: this.msCoID, orderStatus: setType, attrJson: this.attrJson })
            .then((res: any) => {
                let { code, message } = res;
                alert((setType ? '发送' : '保存') + message)
                $btn.button('reset');
            })
    }
    msCoID: any;
    getSomeType() {
        this._localDataService.getThisCompanyHaveSomeType(this.token).then((res: any) => {
            if (res.status) {
                this.msCoID = res.data.filter((item) => item.code === 'W0001')[0]['coBizId'];
            } else {
                console.log(res.message);
            }
        })
    }
    // 图片缩放功能
    degNum: number = 1;
    // 图片放大 
    onBig(event) {
        if (this.degNum <= 2) {
            this.degNum = this.degNum + 0.2
        }
    }
    // 图片缩小
    onSmall(event) {
        if (this.degNum > 0.2) {
            this.degNum = this.degNum - 0.2;
        }
    }
    lineWidth: string = '0px'
    lineHeight: string = '0px'
    lineTop: string = '0px'
    lineLeft: string = '0px'
    // input focus 标记 红色位置
    drawTag(rows) {
        let { width } = this.attrJson;
        let imgwidth = $('.tuoshuimg').find('img').css("width").split("px")[0];
        this.lineWidth = Number(rows.right - rows.left) * Number(imgwidth / width) + 'px';
        this.lineHeight = Number(rows.bottom - rows.top) * Number(imgwidth / width) + 'px';
        this.lineTop = Number(rows.top) * Number(imgwidth / width) + 'px';
        this.lineLeft = Number(rows.left) * Number(imgwidth / width) + 'px';
    }
    // 清除 标记
    clearTag() {
        this.lineWidth = '0px'
        this.lineHeight = '0px'
        this.lineTop = '0px'
        this.lineLeft = '0px'
    }
    // 固定宽度1200  切换
    onLayoutHander() {
        this.isFillLayout = !this.isFillLayout
    }
    // tabs 切换 
    onceSetIframeScore = null;
    onTab(activeTab) {
        this.tabs = activeTab;
        if (activeTab === 'tabs2') {
            $('.iframeScore').height($('.tibcontant').height() - 10)
            if (this.onceSetIframeScore === null) {
                if (this.attrJson.originalPath.toLocaleLowerCase().indexOf("pdf") > -1) {
                    // Pdf
                    this.onceSetIframeScore = this.attrJson.originalPath + '?' + new Date().getTime();
                } else if (/^png|jpg|gif$/g.test(this.attrJson.originalPath)) {
                    this.onceSetIframeScore = this.attrJson.originalPath + '?' + new Date().getTime();
                }
                else {
                    // Excel
                    this.onceSetIframeScore = "https://view.officeapps.live.com/op/view.aspx?src=" + this.attrJson.originalPath + '?' + new Date().getTime();
                }

                $('.iframeScore').attr('src', this.onceSetIframeScore);
            }
        }
    }

    drawLoading() {
        let cvs = <HTMLCanvasElement>document.getElementById('loading-canvans');
        cvs.width = 1200;
        cvs.height = 800;
        let cvsCxt = cvs.getContext('2d');
        cvsCxt.arc(0, 0, 360, 0, 360)
        cvsCxt.stroke();
    }

    openModalType = null;
    openModalName = '';
    // 获取对应的五字码
    onKeyUpHander(event, type) {
        event.preventDefault();
        event.stopPropagation();
        this.openModalType = type;
        this.openModalName = event.target.previousSibling.previousSibling.innerText.replace(/[A-z]/g, '');
        event.target.blur()
        this._localDataService.getCodeByName({ portName: event.target.value, token: this.token })
            .then((res: any) => {
                console.log(res);

                const { code, data, message } = res;
                if (code !== 200) {
                    return alert(message);
                }
                this.attrJson[type].value = data;
                if (data === '') {
                    $('#myModal').modal('show');
                    this.searchForm.portName = event.target.value;
                    this.onMPSearchHander(event);
                }
            })
    }
    tableData: any = [];
    searchForm: any = { portName: '', portCode: '' };
    onMPSearchHander(event) {
        try {
            this._localDataService.getPostCodeList({ ...this.searchForm, token: this.token })
                .then((res: any) => {
                    console.log(res);

                    const { code, data, message } = res;
                    if (code !== 200) {
                        return alert(message)
                    }
                    if (data.length > 0) {
                        this.tableData = data;
                        this.onClickTd(null, 0)
                        return
                    }
                    this.tableData = data;
                    this.checkedIdx = -1
                })
        } catch (error) {
        }

    }

    // td 点击
    checkedIdx: number = 0;
    focusIdx: number = 0;
    hasKeyEvent = null;
    onClickTd(event, tdIdx) {
        this.checkedIdx = tdIdx;
        this.bindBoard()
    }
    bindBoard() {
        const modalEl = document.querySelector('#myModal');
        if (this.hasKeyEvent) {
            modalEl.removeEventListener('keyup', this.hasKeyEvent, true);
        }
        const ctxBoard = this.tableBoard(this.checkedIdx);
        this.hasKeyEvent = ctxBoard;
        modalEl.addEventListener('keyup', ctxBoard, true);
    }
    tableBoard(checkedIdx) {
        let tdIdx = checkedIdx;
        let scrollElement = document.querySelector('.modal-body-table') as HTMLElement;
        let tr = scrollElement.querySelectorAll('tr');
        let scrollHeight = scrollElement.offsetHeight;
        return (event) => {
            event.preventDefault()
            event.stopPropagation()
            if (this.portNameEnter(event) === false) {
                return
            }; // 港口名称 回车

            if (event.target.tagName === 'INPUT' && event.keyCode === 13) {
                event.target.blur()
                this.onMPSearchHander(event);
                return;
            }
            if (event.target.tagName === 'BUTTON' && event.keyCode === 13) {
                return;
            }
            if (this.tableData.length) {
                // 向上
                if (event.keyCode === 38 && tdIdx) {
                    tdIdx--;
                    if ((tr[tdIdx].offsetTop - scrollHeight / 2) <= scrollElement.scrollTop) {
                        scrollElement.scrollTop = tr[tdIdx].offsetTop - scrollHeight / 2;
                    }
                }
                // 向下
                if (event.keyCode === 40 && tdIdx < this.tableData.length - 1) {
                    tdIdx++;
                    if ((tr[tdIdx].offsetTop - scrollHeight / 2) > scrollElement.scrollTop) {
                        scrollElement.scrollTop = tr[tdIdx].offsetTop - scrollHeight / 2;
                    }
                }
                this.focusIdx = tdIdx;
                if (event.keyCode === 13 && tdIdx !== this.checkedIdx) {
                    this.checkedIdx = tdIdx;
                } else if (event.keyCode === 13 && tdIdx === this.checkedIdx) {
                    this.backfill();
                }
            }
        }
    }
    portNameEnter(event) {
        if (event.target.tagName === 'INPUT' && event.keyCode === 13) {
            event.target.blur()
            this.onMPSearchHander(event);
            return false;
        }
        if (event.target.tagName === 'BUTTON' && event.keyCode === 13) {
            return false;
        }

    }
    verifyMpCode(event, type) {
        this._localDataService.getCodeByName({ portName: event.target.value, token: this.token })
            .then((res: any) => {
                console.log(res);

                const { code, data, message } = res;
                if (code !== 200) {
                    return alert(message);
                }
                this.attrJson[type].value = data;
            })
    }
    backfill() {
        const data = this.tableData.filter((it, idx) => idx === this.checkedIdx)
        try {
            if (data.length) {
                const mp = this.openModalType;
                const name = this.openModalType.replace('MP', 'Standard');
                this.attrJson[mp].value = data[0].portCode || '';
                this.attrJson[name].value = data[0].portName || '';
            }
        } catch (error) {
            alert('回车选中数据失败请开发者检查')
        }
        $('#myModal').modal('hide')
    }
    portForm:any = { portName: '', portCode: '', countryCode: '', countryName: '', countryEnName: '' }
    portVName = false;
    portVCode = false;
    updateOrAddPortCode() {
        if (this.portForm.portName === '') {
            this.portVName = true;
            return;
        }
        this.portVName = false;
        if (!/^[A-Z]{5}$/.test(this.portForm.portCode)) {
            this.portVCode = true;
            return;
        }
        this.portVCode = false;
        this._localDataService.updateOrAddPortCode({ ...this.portForm, token: this.token })
            .then((res: any) => {
                const { code, data, message } = res;
                if (code !== 200) {
                    return alert(message);
                }
                alert(message);
                $('#exampleModal').modal('hide')
            })


    }
    portCodeArray: any[] = []
    dorpDown: boolean = false
    portCodeInput() {
        if (this.searchForm.portCode !== '') {
            this._localDataService.getCodeByCode({ portCode: this.searchForm.portCode, token: this.token })
                .then((res: any) => {
                    const { code, data, message } = res;
                    if (code !== 200) {
                        return alert(message)
                    }
                    this.dorpDown = true;
                    this.portCodeArray = data;

                })
        } else {
            this.dorpDown = false;
            this.portCodeArray = [];
        }

        console.log('input1');
    }
    throttle(fn, second) {
        if (fn.timer) {
            clearTimeout(fn.timer);
        }
        fn.timer = setTimeout(() => {
            fn.call(this)
        }, second)
    }
    portCodeBlur(event) {
        setTimeout(() => {
            this.dorpDown = false
        }, 200)
    }
    deletePortCode(event, mp) {
        debugger
        event.stopPropagation();
        const { id, portType } = mp
        if (id && portType) {
            this._localDataService.deletePortCode({ id: id, token: this.token })
                .then((res: any) => {
                    const { code, data, message } = res
                    if (code !== 200) {
                        return alert(message);
                    }
                    alert(message)
                    this.onMPSearchHander(event)
                })
        }
    }
}



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/component/identification/identification.ts